import { DateTimeFormatOptions } from "luxon";
import { tokens } from "@sunrun/experience-ui-components";
import {
  LinkHelpEmail,
  LinkHelpPhone,
} from "checkout/components/atoms/ContactLinks";

const SCHEDULE_SUBTITLE = `A Site Technician will visit your home to make measurements and check for certain requirements - like whether your roof is in good condition or if we need to make electrical updates - to confirm that your home is ready for solar panels.
  Once you’ve scheduled the home review, the status might take a few minutes to update. 
  Please refresh this page.`;
const SCHEDULE_SUBTITLE_NON_SOLAR = `A Site Technician will visit your home to make measurements and check for certain requirements - like whether your roof is in good condition or if we need to make electrical updates - to confirm that your home is ready for Sunrun installation.
  Once you’ve scheduled the home review, the status might take a few minutes to update. 
  Please refresh this page.`;

const SLOTS_ERROR = "We had a problem loading appointments, please try again.";
const SLOTS_ERROR_BUTTON = "Retry";
const SLOTS_UNAVAILABLE_LINE_1 =
  "To book an appointment view dates further out.";
const SLOTS_UNAVAILABLE_LINE_2 =
  "If you're not able to make an appointment, please contact sales support.";
const SLOTS_UNAVAILABLE_BUTTON = "Contact Team";
const SLOTS_UNAVAILABLE_MESSAGE = (
  <>
    <p>
      Sorry but we can&apos;t get more appointments available please contact our
      team to set one manually or fix it.
    </p>
    <p>
      Speak with your manager, or email{" "}
      <LinkHelpEmail linkColor={tokens.BLACK} />, or call Sales Support Desk at{" "}
      <LinkHelpPhone linkColor={tokens.BLACK} />.
    </p>
  </>
);

const INLINE_EMPTY_SLOTS_MESSAGE =
  "No appointments available for these dates. Try moving forward or contact your sales team for help.";

const POST_CAP_EMPTY_SLOTS_MESSAGE =
  "No appointments available for selected dates. Try checking later dates. If issue persists contact sales support desk.";

const HEADER_DATE_FORMAT: DateTimeFormatOptions = {
  weekday: "short",
  month: "short",
  day: "numeric",
};
const HEADER_DATE_FORMAT_LONG: DateTimeFormatOptions = {
  weekday: "long",
  month: "long",
  day: "numeric",
};
const SLOT_TIME_FORMAT: DateTimeFormatOptions = {
  minute: "2-digit",
  hour: "numeric",
  hourCycle: "h12",
};

const SCHEDULE_APPOINTMENT_ERROR_DESCRIPTION =
  "Our system is having trouble processing your appointment at the moment. Please try again or call Sales Support Desk to resolve the issue.";
const CANCEL_BODY_SITE_SURVEY = (name: string) =>
  `Are you sure you want to cancel the site survey for ${name}?`;

const CANCEL_BODY_POST_CAP_HOME_CHECK = (name: string) =>
  `Are you sure you want to cancel the post design home review for ${name}?`;

const CANCEL_BODY_REMEMBER =
  "Remember, you can still schedule a new appointment.";

export {
  SCHEDULE_APPOINTMENT_ERROR_DESCRIPTION,
  CANCEL_BODY_POST_CAP_HOME_CHECK,
  CANCEL_BODY_REMEMBER,
  CANCEL_BODY_SITE_SURVEY,
  HEADER_DATE_FORMAT,
  HEADER_DATE_FORMAT_LONG,
  INLINE_EMPTY_SLOTS_MESSAGE,
  POST_CAP_EMPTY_SLOTS_MESSAGE,
  SCHEDULE_SUBTITLE,
  SCHEDULE_SUBTITLE_NON_SOLAR,
  SLOT_TIME_FORMAT,
  SLOTS_ERROR,
  SLOTS_ERROR_BUTTON,
  SLOTS_UNAVAILABLE_BUTTON,
  SLOTS_UNAVAILABLE_LINE_1,
  SLOTS_UNAVAILABLE_LINE_2,
  SLOTS_UNAVAILABLE_MESSAGE,
};
